import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareNotificationEmailRoute: InvariantJiraRoute = {
	name: 'project-settings-software-notifications-notification-email',
	path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
	exact: true,
};
